import { Injectable, effect, inject, signal } from '@angular/core';
import { SessionStorageService } from './session-storage.service';

export interface Theme {
  id: string;
  primary: string;
  displayName: string;
}

@Injectable({ providedIn: 'root' })
export class ThemeService {
  private ss = inject(SessionStorageService);

  private readonly themes: Theme[] = [
    {
      id: 'RightBridge',
      primary: '#265b97',
      displayName: 'RightBridge',
    },
    {
      id: 'StateFarm',
      primary: '#ED1D24',
      displayName: 'StateFarm',
    },
  ];
  currentTheme = signal<Theme>(this.themes[0]);
  currentScheme = signal<string>('light');
  firmTheme = signal<string>('');

  getThemes(): Theme[] {
    return this.themes;
  }

  setTheme(themeId: string): void {
    const theme = this.themes.find(theme => theme.id === themeId);
    if (themeId !== '') {
      this.ss.set('colorTheme', themeId);
    } else {
      this.ss.remove('colorTheme');
    }
    if (theme) {
      this.currentTheme.set(theme);
    }
  }

  setColorScheme(scheme: string): void {
    if (scheme !== '') {
      this.ss.set('colorScheme', scheme);
    } else {
      this.ss.remove('colorScheme');
    }
    if (scheme !== this.currentScheme()) {
      document.body.classList.remove(this.currentScheme());
      document.body.classList.add(scheme);
      this.currentScheme.set(scheme);
    }
  }

  updateThemeClass = effect(() => {
    const newTheme = this.currentTheme();
    document.body.classList.remove(
      ...this.themes.map(theme => `${theme.id}-theme`)
    );
    document.body.classList.add(`${newTheme.id}-theme`);
  });

  updateSchemeClass = effect(() => {
    document.body.classList.remove('light');
    document.body.classList.remove('dark');
    document.body.classList.add(this.currentScheme());
  });
}
